import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Space, Typography } from "antd";
import { CafeOrderSimple } from '../../../../base-react/components/CafeOrderSimple';
import { HeaderContainer, BodyContainer } from '../../../../base-react/components/Container';
import { _T } from '../../../../base-react/src/Localization';
const { Title } = Typography;
export const Cafe = () => {
    const { event_id } = useParams();
    const cafeOrdersUrl = `/cafe/event/${event_id}/orders`;
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, { level: 2 }, _T('cafe.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(Space, { orientation: "vertical", size: "large", style: { width: '100%' } },
                React.createElement(Space, null,
                    React.createElement("a", { href: cafeOrdersUrl, target: "_blank", rel: "noopener noreferrer" },
                        React.createElement(Button, { type: "primary" }, _T('cafe.orders.manage')))),
                React.createElement(CafeOrderSimple, { competitionId: event_id })))));
};
